import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/components/ui/cn';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}

export function Card({ title, description, actions, className, children, ...props }: CardProps) {
  const hasHeader = title || description || actions;
  return (
    <div
      className={cn('rounded-lg border border-gray-200 bg-white p-5 shadow-sm', className)}
      {...props}
    >
      {hasHeader && (
        <div className="mb-4 flex items-start justify-between gap-4">
          <div>
            {title && <h2 className="text-base font-semibold text-gray-900">{title}</h2>}
            {description && <p className="mt-1 text-sm text-gray-500">{description}</p>}
          </div>
          {actions && <div className="shrink-0">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
